import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Notifications() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { if (user === false) nav("/login"); }, [user]);
  useEffect(() => { if (user) { api.get("/notifications").then((r) => setItems(r.data)); api.post("/notifications/read-all"); } }, [user]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold mb-5 flex items-center gap-2"><Bell className="text-emerald-600" /> Notifications</h1>
      {items.length === 0 ? <div className="text-center py-20 text-slate-400">No notifications.</div> : (
        <div className="space-y-2">{items.map((n) => (
          <button key={n.id} data-testid={`notif-${n.id}`} onClick={() => n.order_id && nav(`/orders/${n.order_id}`)} className="w-full text-left bg-white rounded-xl border border-slate-100 p-4 hover:shadow-sm transition-shadow">
            <p className="font-bold text-sm">{n.title}</p><p className="text-sm text-slate-500">{n.body}</p>
            <p className="text-xs text-slate-400 mt-1">{new Date(n.created_at).toLocaleString("en-IN")}</p>
          </button>
        ))}</div>
      )}
    </div>
  );
}
